import Vue from 'vue'
import App from './App'
import router from './router'
import requestService from '@/config/request'
import store from './store'
import axios from 'axios'
import Router from 'vue-router'
import "./mock"
import Vuex from 'vuex'

//通过Vue.use来使用vuex
Vue.use(Vuex)
Vue.use(Router)
Vue.prototype.$ajax = axios


// 获取echarts对象，进行挂载
Vue.prototype.$echarts = window.echarts;

//请求基准路径的配置
axios.defaults.baseURL = '/'
//将axios挂在到Vue的原型对象上
//其他组件引入时用 this.$http
Vue.prototype.$http = requestService

 
Vue.config.productionTip = false

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })

new Vue({
  router, 
  store,
  render: h => h(App)
}).$mount("#app")
